/**
 * Labour / charge buckets used in Financials (summary breakdown).
 * Vendor “type” options are seeded from the same list so naming stays aligned.
 */
export const FINANCIALS_LABOUR_CATEGORIES = [
  'Carpenter Charges',
  'Electrician Charges',
  'POP Charges',
  'Glass Charges',
  'Transportation',
  'CNC Charges',
  'Other',
];
